import React, { Fragment } from 'react'
import cx from 'classnames'
import { useUniqueId, useMemo } from 'sb-hooks'
import { constants } from 'common/helpers'

import { Box } from 'components/_new/layout'
import Text from 'components/_new/typography/Text/Text'
import CloseIcon from 'components/ui/CloseIcon/CloseIcon'
import { CircleLoader } from 'components/_new/ui'
import { HelpIconWithTooltip } from 'components/_new/controls'

import s from './BillRow.scss'


export type BillRowProps = {
  id?: string
  label: ReactIntlMessage
  value: ReactIntlMessage | string
  brand?: boolean
  note?: ReactIntlMessage | null
  isFetching?: boolean
  tooltip?: ReactIntlMessage
  onRemove?: () => void
}

const BillRow: React.FunctionComponent<BillRowProps> = (props) => {
  const { label, value, tooltip, isFetching, brand, id, note, onRemove } = props

  // TODO this is ductape
  // the value must be both white-space: wrap and nowrap
  // `wrap` for long test
  // `nowrap` for price `- $30` bcs if label is too long `-` and `$30` on different lines
  // so we need to check if value is price value then replace `space` with `&nbsp;` to prevent from wrapping
  // BEST WAY: add &nbsp; to formatPrice() but then we need to render result as node, not like string...
  const _value   = useMemo(() => typeof value === 'string' && /^-\s\$[\d.]+$/.test(value) ? value.replace(' ', '&nbsp;') : value, [ value ])
  const withNote = Boolean(note)

  const helpId = useUniqueId('help')

  const valueClassName = cx(s.value, {
    [s.brandColor]: brand,
    [s.multiline]: typeof value === 'string' && value.length > 20,
  })

  return (
    <Fragment>
      <Box mt={16} className={s.item}>
        <div className={s.label}>
          <Text message={label} dataTestId={`${id}Label`} tag="span" align="left" html />
          {
            Boolean(tooltip) && (
              <span className={s.tooltip}>
                <HelpIconWithTooltip message={tooltip} id={helpId} />
              </span>
            )
          }
          {
            typeof onRemove === 'function' && (
              <CloseIcon
                className={s.removeButton}
                onClick={onRemove}
                dataTestId={constants.testIds.payment.removeOrderItem}
              />
            )
          }
        </div>
        {
          isFetching ? (
            <CircleLoader />
          ) : (
            <div className={valueClassName}>
              <Text message={_value} tag="span" dataTestId={`${id}Value`} html />
              {
                withNote && (
                  <sup className={s.asterix}>*</sup>
                )
              }
            </div>
          )
        }
      </Box>
      {
        !isFetching && withNote && (
          <div className={s.noteWrapper}>
            <sup className={s.asterix}>*</sup>
            <Box ml={4}>
              <Text
                className={s.note}
                message={note}
                dataTestId={`${id}Note`}
                size="14-24"
                color="gray"
              />
            </Box>
          </div>
        )
      }
    </Fragment>
  )
}


export default BillRow
